<template>
  <BreastHarmonyForm />
</template>

<script>
import BreastHarmonyForm from './components/BreastHarmonyForm.vue'

export default {
  name: 'App',
  components: {
    BreastHarmonyForm
  },
  mounted() {
    document.title = 'MIA Femtech - Brusttest | theaesthetics'
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
